import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../../components/common/skeleton';

/*
 * Props.
 */

interface SettingsSearchDropdownLoadingItemProps {}

/*
 * Style.
 */

const StyledLoadingItemDiv = styled.div`
  height: 48px;
  display: grid;
  grid-template-areas:
    'avatar title'
    'avatar subtitle';
  grid-template-columns: 32px auto;
  grid-row-gap: 5px;
  grid-column-gap: 12px;
  padding: 0 12px;
`;

const StyledLoadingAvatar = styled(Skeleton)`
  grid-area: avatar;
  height: 32px;
  width: 32px;
  margin-top: 8px;
  border-radius: 50%;
`;

const StyledLoadingTitle = styled(Skeleton)`
  grid-area: title;
  width: 30%;
  max-width: 140px;
  height: 16px;
  border-radius: 4px;
  margin-top: 6px;
`;

const StyledLoadingSubtitle = styled(Skeleton)`
  grid-area: subtitle;
  max-width: 344px;
  width: 80%;
  border-radius: 4px;
  margin-top: -5px;
`;

/*
 * Component.
 */

export const SettingsSearchDropdownLoadingItem: FC<SettingsSearchDropdownLoadingItemProps> = (props) => (
  <StyledLoadingItemDiv>
    <StyledLoadingAvatar scheme={SkeletonColorSchemesEnum.GREY30} />
    <StyledLoadingTitle scheme={SkeletonColorSchemesEnum.GREY30} />
    <StyledLoadingSubtitle scheme={SkeletonColorSchemesEnum.GREY10} />
  </StyledLoadingItemDiv>
);
